import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { ACCOUNT_TYPES_DICT } from '../DarkWebConstants';
import { deleteBankAccount } from '../../../../ExperianActions';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import ExperianContext from '../../../../ExperianContext';

const BankAccounts = ({ title, data }) => {
  const [accountToDelete, setAccountToDelete] = useState(null);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const getAccountText = (accountType, accountNumber, bankRouting) =>
    `${ACCOUNT_TYPES_DICT[accountType]} ${accountNumber} ${bankRouting || ''}`;

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deleteBankAccount(clientId, subscriberId, accountToDelete.AccountNumberLabel));
    setAccountToDelete(null);
  }, [clientId, subscriberId, accountToDelete, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            {data.map(account => {
              const {
                AccountType: accountType,
                AccountNumber: accountNumber,
                AccountNumberLabel: accountNumberLabel,
                BankRouting: bankRouting,
              } = account;

              return (
                <DataItem key={accountNumberLabel}>
                  <DeleteIcon onClick={() => setAccountToDelete(account)} />
                  <DataItemText>
                    {getAccountText(accountType, accountNumber, bankRouting)}
                  </DataItemText>
                </DataItem>
              );
            })}
          </ItemContent>
        </div>
        {!!accountToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => setAccountToDelete(null)}
          >
            Are you sure you want to stop monitoring:
            <br />
            {getAccountText(
              accountToDelete.AccountType,
              accountToDelete.AccountNumber,
              accountToDelete.BankRouting,
            )}
            ?
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default BankAccounts;
